import { defineStore } from "pinia";

export const useEmbedStore = defineStore("embedStore", {
  state: () => ({
    isEmbed: false,
  }),
  actions: {
    setEmbed(value: boolean) {
      this.isEmbed = value;
    },
  },
});
